<template>
  <div>
    <Modal ref="modal" modalDialogStyle="width: 100vw; height: 100vh; margin: 0;">
      <template #button>
        <button ref="button" v-show="label.length > 0" :class="btnClass" :style="btnStyle" @click="request_lti">{{label}}</button>
      </template>
      <template #content>
        <iframe :name="iframeName" style="width: 100%; height: 100%;"></iframe>
      </template>
    </Modal>
  </div>
</template>
<script>
import Modal from '@/components/Utility/Modal'
export default {
  components: {
    Modal
  },
  props: {
    btnClass: {
      type: String,
      default: 'btn btn-fill btn-success'
    },
    btnStyle: {
      type: String,
      default: 'font-size: 20pt;'
    },
    courseId: Number,
    activityId: {
      type: Number,
      default: 0
    },
    label: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      iframeName: this.getNewId()
    }
  },
  methods: {
    request_lti: async function () {
      this.$message('正在開啓uReply')
      console.log(this.courseId)
      console.log(this.activityId)
      let fd = new FormData()
      fd.append('course_id', this.courseId)
      if (this.activityId > 0) {
        fd.append('activity_id', this.activityId)
      }
      let result = await this.$store.dispatch('request', {
        route: `lti/requests`,
        method: 'post',
        data: fd
      })
      console.log(result)
      // console.
      let form = document.createElement('form')
      form.target = this.iframeName
      form.action = result.url
      form.method = 'post'
      Object.entries(result.fields).forEach((v, k) => {
        let input = document.createElement('input')
        input.value = v[1]
        input.name = v[0]
        form.appendChild(input)
      })
      console.log(form)
      document.body.appendChild(form)
      form.submit()
      document.body.removeChild(form)
      this.$refs.modal.open()
    },
    getNewId: function () {
      let numberic = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
      let randomString = function (n) {
        let result = ''
        for (var i = 0; i < 10; i++) {
          result += numberic.charAt(Math.floor(Math.random() * numberic.length))
        }
        return result
      }
      let id = 'uReply'
      // modalId = randomString(10)
      // $('#fsd')
      return id + '_' + randomString(10)
      // console.log($(`#${id}`))
      // do {
      //   id = id + '_' + randomString(10)
      // } while ($(`#${id}`).length > 1)
      // return id
    }
  },
  mounted () {
    window.addEventListener('message', (e) => {
      console.log('on message')
      console.log(e)
      console.log(this.$refs.modal)
      if (e.origin === 'https://ureply.fabulearn.net') {
        this.$refs.modal.close()
      }
    })
  }
}
</script>
